// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3SUcr","title":"Header_title__kZkz9","side":"Header_side__2Trvv"};